import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedProjectsShowProjectVersionsShowFilesRoute extends BaseRoute {}
